import React from "react";

import { RiErrorWarningLine } from "react-icons/ri";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";

import * as S from "./styles";
import { TConfirmAntecipateSaleModal } from "./types";

import designSystemColors from "../../../../../styles";
import { Separator } from "../../../../NewLogin/style";
import DSButton from "../../../../../components/DSButton";

const ConfirmAntecipateSaleModal = ({
  type,
  visible,
  onClose,
  antecipatePartial,
  antecipateTotal,
  loading,
  idVenda,
  selectedSaleData,
  numeroParcela,
}: TConfirmAntecipateSaleModal) => {
  return (
    <S.AntModal
      open={visible}
      onCancel={onClose}
      closable={!loading}
      maskClosable={!loading}
      data-test-id="modal-confirmar-antecipação"
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          marginBottom: "1rem",
        }}
      >
        <RiErrorWarningLine
          style={{ color: designSystemColors.generalButtons }}
          size={20}
        />
        <S.ModalTitle>Antecipação de Vendas</S.ModalTitle>
      </div>

      <S.Description>Deseja confirmar a antecipação?</S.Description>

      <S.SalesListContainer>
        <S.Wrapper>
          <S.Key>Venda:</S.Key>
          <S.Value>{selectedSaleData?.descricaoProduto}</S.Value>
        </S.Wrapper>
        <S.Wrapper>
          <S.Key>Parcelas a antecipar:</S.Key>
          <S.Value>
            {type === "total"
              ? `${selectedSaleData?.numeroParcelasAntecipaveis}`
              : `${numeroParcela}`}
          </S.Value>
        </S.Wrapper>
        <S.Wrapper>
          <S.Key>Valor Inicial Parcela:</S.Key>
          <S.Value>R$ {selectedSaleData?.valorParcela}</S.Value>
        </S.Wrapper>
      </S.SalesListContainer>

      <S.ButtonWrapper>
        <DSButton
          dataTestId="btn-cancelar-antecipação"
          style={{
            height: 32,
            padding: "8px",
            fontWeight: "bold",
          }}
          disabled={loading}
          isIconAfter={false}
          isCancelType
          buttonType="secondary"
          buttonText="Cancelar"
          onClick={onClose}
        />

        <DSButton
          dataTestId={`btn-confirmar-antecipação-${
            type === "partial" ? "parcial" : "total"
          }`}
          style={{
            height: 32,
            padding: "8px",
          }}
          isLoading={loading}
          disabled={loading}
          buttonType="secondary"
          buttonText="Confirmar"
          onClick={
            type === "partial"
              ? () =>
                  antecipatePartial(
                    numeroParcela as string,
                    idVenda,
                    selectedSaleData?.numeroParcelas
                  )
              : () => antecipateTotal(idVenda)
          }
        />
      </S.ButtonWrapper>
    </S.AntModal>
  );
};

export default ConfirmAntecipateSaleModal;
